import {
  IconBrandX,
  IconMail,
  IconPhone,
  IconLocation,
  IconClockHour9,
  IconBrandFacebook,
  IconBrandTiktok,
  IconBrandInstagram,
  IconBrandWhatsapp,
  IconBrandYoutube,
  IconChevronLeft,
  IconChevronRight,
  IconCalendarEvent,
  IconKey,
} from "@tabler/icons-react"

type Props = {
  className?: string
  size?: number
  stroke?: number
  color?: string
}

export const BrandXIcon = (props: Props) => <IconBrandX {...props} />
export const MailIcon = (props: Props) => <IconMail {...props} />
export const PhoneIcon = (props: Props) => <IconPhone {...props} />
export const LocationIcon = (props: Props) => <IconLocation {...props} />
export const ClockHour9Icon = (props: Props) => <IconClockHour9 {...props} />
export const BrandFacebookIcon = (props: Props) => <IconBrandFacebook {...props} />
export const BrandTiktokIcon = (props: Props) => <IconBrandTiktok {...props} />
export const BrandInstagramIcon = (props: Props) => <IconBrandInstagram {...props} />
export const BrandWhatsappIcon = (props: Props) => <IconBrandWhatsapp {...props} />
export const BrandYoutubeIcon = (props: Props) => <IconBrandYoutube {...props} />
export const ChevronLeftIcon = (props: Props) => <IconChevronLeft {...props} />
export const ChevronRightIcon = (props: Props) => <IconChevronRight {...props} />
export const CalendarEventIcon = (props: Props) => <IconCalendarEvent {...props} />
export const KeyIcon = (props: Props) => <IconKey {...props} />
